import {LocalStorage} from "../../utils/storage";

export const Permissions = {
    // Keep this list alphabetically sorted by key.
    ALERTS: 'alerts',
    BARCODE_LABEL_SETTINGS: 'barcode_label_settings',
    BATCH_REQUESTS: 'batch_requests',
    CLOUD_STORAGE: 'cloud_storage',
    CONTROL_RECORDS: 'control_records',
    COST_RECORDS: 'cost_records',
    CUSTOMERS: 'customers',
    CUSTOM_FORMS: 'custom_forms',
    CUSTOM_FORM_SETTINGS: 'custom_form_settings',
    FINISHED_PRODUCTIONS: 'finished_productions',
    FORMULAS: 'formulas',
    GENERAL_SETTINGS: 'general_settings',
    IDENTIFICATION_PRODUCTIONS: 'identification_productions',
    KPI: 'kpi',
    LOCATION_SETTINGS: 'location_settings',
    NONCONFORMITY: 'nonconformity',
    ORGANIZATION: 'organization',
    PRODUCTIONS: 'productions',
    PRODUCT_DISTRIBUTION: 'product_distribution',
    PRODUCT_ORDERS: 'product_orders',
    PRODUCT_SETTINGS: 'product_settings',
    PRODUCT_STOCK: 'product_stock',
    PRODUCT_STOCK_DECREASE: 'product_stock_decrease',
    PRODUCTION_SETTINGS: 'production_settings',
    RAW_MATERIAL_SETTINGS: 'raw_material_settings',
    RAW_MATERIAL_RECEPTION: 'raw_material_reception',
    RAW_MATERIAL_STOCK: 'raw_material_stock',
    RAW_MATERIAL_STOCK_DECREASE: 'raw_material_stock_decrease',
    REPROCESS_STOCK: 'reprocess_stock',
    ROLE_PERMISSIONS: 'roles_permissions',
    STARTED_PRODUCTIONS: 'started_productions',
    SUPPLY_SETTINGS: 'supply_settings',
    SUPPLY_RECEPTION: 'supply_reception',
    SUPPLIERS: 'suppliers',
    SUPPLY_STOCK: 'supply_stock',
    SUPPLY_STOCK_DECREASE: 'supply_stock_decrease',
    TRACEABILITY: 'traceability',
  }

  export const permissionTypes ={
      WRITE: 'write',
      READ: 'read'
  }

export const hasPermission = (permission, permission_type = null) =>{
    const userPermissions = LocalStorage.get('permissions')
    return userPermissions? userPermissions.some((e) => e.name == permission && (!permission_type || e.permission_type == permission_type)) : false
  }

export const hasAnyPermission = (needed_permissions) => {
    const userPermissions = LocalStorage.get('permissions')? LocalStorage.get('permissions').map((e) => e.name) : []
    return needed_permissions.some(e => {return userPermissions.includes(e)})
}
